export const RelationshipEnum = {
  FATHER: 'Pai',
  MOTHER: 'Mãe',
  SIBLING: 'Irmã(o)',
  SPOUSE: 'Cônjuge',
  OTHER: 'Outro'
} as const